<template>
  <v-dialog scrollable v-model="dialog" width="800">
    <v-card rounded="lg">
      <v-card-text class="text--primary px-12 pt-12">
        <v-alert
          v-if="false"
          outlined
          color="primary"
          border="left"
          rounded="lg"
        >
          Mantenimiento programado para el día de hoy, de 13hs a 15hs.
        </v-alert>

        <h1>InManager - Changelog</h1>

        <h2 class="py-4">23-08-2023</h2>

        <h3>Novedades</h3>
        <ul>
          <li>
            Primera versión de la funcionalidad para vincular contactos, aún en
            pruebas a través de base de datos directamente. Implementación
            visual en curso.
          </li>
        </ul>

        <h3 class="mt-3">Mejoras</h3>
        <ul>
          <li>
            Cerrar sesión automáticamente al cerrar navegador o pestaña.
          </li>
        </ul>

        <h2 class="py-4">14-08-2023</h2>

        <h3>Mejoras</h3>
        <ul>
          <li>
            Actualización automática de locador al editar el propietario de un
            inmueble en alquiler.
          </li>
        </ul>

        <h2 class="py-4">14-08-2023</h2>

        <h3>Correcciones</h3>
        <ul>
          <li>
            Actualización de información de búsqueda de propiedades al cambiar
            el tipo de operación.
          </li>
        </ul>

        <h2 class="py-4">09-08-2023</h2>

        <h3>Mejoras</h3>
        <ul>
          <li>Mantener pagos al eliminar impuesto que los agrupa.</li>
          <li>
            Evitar que se editen pagos pendientes de meses anteriores al editar
            un impuesto.
          </li>
        </ul>

        <h3 class="mt-3">Correcciones</h3>
        <ul>
          <li>
            Monto duplicado de Expensas al editar formas de pago en un recibo.
          </li>
          <li>Cambio de "Alquiler" a "Resolución anticipada".</li>
        </ul>

        <h3 class="mt-3">Próximamente</h3>
        <ul>
          <li>Sección de analíticas.</li>
        </ul>

        <h2 class="py-4">03-08-2023</h2>

        <h3>Mejoras</h3>
        <ul>
          <li>Limpieza de pagos desactualizados.</li>
          <li>Optimización en carga de listado de asientos.</li>
          <li>Mantenimiento programado de servidor.</li>
        </ul>

        <h3 class="mt-3">Correcciones</h3>
        <ul>
          <li>Reducción de caché en listado de asientos.</li>
        </ul>

        <h2 class="py-4">31-07-2023</h2>

        <h3>Novedades</h3>
        <ul>
          <li>Nuevo modelo de rescisión de contratos.</li>
          <li>Alerta de rescisión de contratos.</li>
          <li>Sección de novedades de la plataforma.</li>
        </ul>

        <h3 class="mt-3">Mejoras</h3>
        <ul>
          <li>Mejoras en listado de contratos.</li>
          <li>Mejoras en filtrado de asientos.</li>
        </ul>

        <h3 class="mt-3">Correcciones</h3>
        <ul>
          <li>Asignar usuarios a formulario de inversión.</li>
        </ul>

        <h3 class="mt-3">Cambios Generales</h3>
        <ul>
          <li>-</li>
        </ul>

        <h3 class="mt-6">Agradecimientos</h3>
        <p>
          Agradecemos a nuestra comunidad de usuarios por sus valiosos
          comentarios y sugerencias, los cuales nos ayudaron a mejorar la
          aplicación.
        </p>

        <p>Equipo de Revi</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false
  }),

  computed: {
    ...mapGetters(["currentUser"])
  },

  created() {
    if (this.currentUser) {
      this.dialog = !this.currentUser.changelogRead;
    }
  },

  watch: {
    currentUser(val) {
      if (val) this.dialog = !this.currentUser.changelogRead;
    }
  }
};
</script>
